import React from 'react';
import { Box } from '@common-fe/common-fe';

import {ROUTES} from '@/common';
import Permissions from '@/common/permissions';
import { Access, Topbar } from '@/modules/core/components';
import { useBreadcrumbs } from '@/modules/core/hooks';
import { RolesList } from '@/modules/role';
import FieldLevelAccessList from '@/modules/role/FieldLevelAccessList';
import { RolesAndSecurityTabs } from '@/modules/role/role.types';
import { RolesAndSecurityHeader } from '@/modules/role/RolesAndSecurityHeader';
import { useRolesAndSecurityTabsStore } from '@/modules/role/stores';
import theme from '@/styles/theme';

const currentPages = [
  RolesAndSecurityTabs.ROLES,
  RolesAndSecurityTabs.FIELD_LEVEL_ACCESS,
];

const RolesAndSecurityPage = () => {
  useBreadcrumbs([{
    route: ROUTES.ROLES_AND_SECURITY,
    title: 'Roles and Security',
  }]);

  const currentTab = useRolesAndSecurityTabsStore((state) => state.currentTab);
  const setCurrentTab = useRolesAndSecurityTabsStore((state) => state.setCurrentTab);

  return (
    <Access
      accessRequirements={[
        { permission: Permissions.VIEW_ROLES_AND_SECURITY },
      ]}
    
    >
      <Box width="100%" margin={{ top: '0' }} height="fit-content">
        <Topbar />
        <Box align="center" pad={{ bottom: 'spacing72' }}>
          <Box pad={{top: 'l'}} width={theme.defaultContentWidth}>
            <RolesAndSecurityHeader
              currentTab={currentTab}
              tabs={currentPages}
              onSetCurrentTab={setCurrentTab}
            />
            {currentTab === RolesAndSecurityTabs.ROLES && <RolesList />}
            {currentTab === RolesAndSecurityTabs.FIELD_LEVEL_ACCESS && <FieldLevelAccessList />}
          </Box>
        </Box>
      </Box>
    </Access>
  );
};
export default RolesAndSecurityPage;